import { render, staticRenderFns } from "./memberService.vue?vue&type=template&id=5476f3c8&scoped=true"
import script from "./memberService.vue?vue&type=script&lang=js"
export * from "./memberService.vue?vue&type=script&lang=js"
import style0 from "./memberService.vue?vue&type=style&index=0&id=5476f3c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5476f3c8",
  null
  
)

export default component.exports